const technicalDataEl = document.querySelector('[data-technical]');
const technicalData = technicalDataEl
  ? JSON.parse(technicalDataEl.textContent)
  : {};

const getVariantInventory = async (variantId) =>
  fetch(
    `
    ${technicalData.discountsApi}/api/shopify/variant/inventory/${
      window.STOREFRONT === 'LC' ? 'lc' : 'ml'
    }
    `,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        variantId,
        locationId: technicalData.inventoryLocationId,
      }),
    },
  )
    .then((response) => response.json())
    .then((data) => ({
      data,
    }));

window.getVariantInventory = getVariantInventory;

export default getVariantInventory;
